import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { JwtService } from 'src/app/core/services/jwt.service';
import { D7_LOGIN_ROUTE } from '../constants/routes.constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private jwtService: JwtService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    if (this.jwtService.isToken()) {
      if (this.jwtService.tokenExpired()) {
        this.redirectLogin();
        return false;
      }

      return true;
    }

    this.router.navigateByUrl(D7_LOGIN_ROUTE);
    return false;
  }

  private redirectLogin(): void {
    this.jwtService.destroyToken();
    this.router.navigate([D7_LOGIN_ROUTE]);
  }
}
